export default __webpack_public_path__ + "static/media/nd.4330ab23.png";